<script setup lang="ts">
import { useConfirm } from '@/shared/ui'
import { useTranslate } from '@/shared/lib'
import { useCabinetInit } from '@/features/Cabinet/AdminCommands/model/api.ts'

const props = defineProps({
  cabinetId: {
    type: Number,
    default: 0,
    required: false,
  },
})

const { show } = useConfirm()
const { trs } = useTranslate()
const { send } = useCabinetInit()

/**
 * Функция обработки отправки команды
 */
const clickHandler = () => {
  show({
    title: trs('itf.confirm_command'),
    confirmFunc: () => send('schedule', props.cabinetId),
  })
}
</script>

<template>
  <div @click="clickHandler">
    <slot />
  </div>
</template>
